import { useQuery } from '@tanstack/react-query';
import http from "@/lib/http";

const fetchCountry = async () => {
  const res = await http.get('https://api.country.is');
  if (res.status !== 200) throw new Error('Failed to fetch');
  return res.data;
};

export const useTopBarApi = () => {
  const { data, error, isLoading } = useQuery({
    queryKey: ['userCountry'],
    queryFn: fetchCountry,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 1,
  });

  const isIndia = data?.country?.toUpperCase() === 'IN';
  const countryCode = data?.country?.toUpperCase() || null;

  let whatsappNumber = '+1 (732) 485-2499';
  let whatsappLink = 'https://wa.me/17324852499';

  if (!error && data && isIndia) {
    whatsappNumber = '+91-949-032-3388';
    whatsappLink = 'https://wa.me/919490323388';
  }

  return {
    whatsappNumber,
    countryCode,
    whatsappLink,
    isLoading,
    error,
  };
};
